import { z } from 'zod'

/**
 * Copy of {@link PointDto} but with coerce for parse
 */
export const PointCoerceSchema = z.object({
	latitude: z.coerce.number(),
	longitude: z.coerce.number()
})
